import React, { Component } from 'react';
import { Button, Modal, Input, Form, Popover } from 'antd';
import styles from './../DepartmentSettings/department-settings.module.sass';
import { InfoCircleFilled } from '@ant-design/icons';
import {
  showNotification,
  simpleErrorNotification,
} from '../../../../shared-components/Notifications';

class WebhookModal extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
  }

  handleSubmit = () => {
    const data = this.form.current?.getFieldsValue();

    if (
      !data?.webhook_url.includes(',') &&
      data?.webhook_url.includes('.') &&
      (data?.webhook_url.substring(0, 7).includes('http://') ||
        data?.webhook_url.substring(0, 8).includes('https://')) &&
      !(data?.webhook_url[0] === '.') &&
      !(data?.webhook_url[data?.webhook_url.length - 1] === '.')
    ) {
      if (this.props.currentIntegrationType === 'Slack') {
        this.props.onSlackSubmit(data);
      } else if (this.props.currentIntegrationType === 'MTeams') {
        this.props.onMTeamsSubmit(data);
      }
    } else {
      showNotification(
        simpleErrorNotification({
          statusCode: 503,
          message: 'Please input the correct url.',
        }),
      );
    }

    this.form.current.resetFields();
  };

  render() {
    const {
      show,
      currentSlackIntegration,
      currentMTeamsIntegration,
      currentIntegrationType,
    } = this.props;
    if (!show) return null;

    const popoverContent = (
      <div>
        For more information visit{' '}
        <a
          style={{ textDecoration: 'underline' }}
          href={
            (currentIntegrationType === 'Slack' &&
              'https://api.slack.com/messaging/webhooks') ||
            (currentIntegrationType === 'MTeams' &&
              'https://docs.microsoft.com/en-us/microsoftteams/platform/webhooks-and-connectors/how-to/add-incoming-webhook')
          }
        >
          this site
        </a>
      </div>
    );

    const currentIntegration =
      (currentIntegrationType === 'Slack' && currentSlackIntegration) ||
      (currentIntegrationType === 'MTeams' && currentMTeamsIntegration);

    return (
      <Modal
        title={
          (currentIntegrationType === 'Slack' && 'Slack Integration') ||
          (currentIntegrationType === 'MTeams' && 'Microsoft Teams Integration')
        }
        className={styles.modal}
        visible
        onCancel={this.props.onCancel}
        footer={[
          <Button key="cancel" onClick={this.props.onCancel}>
            Cancel
          </Button>,

          <Button key="submit" type="primary" onClick={this.handleSubmit}>
            {currentIntegration ? 'Update' : 'Integrate'}
          </Button>,
        ]}
      >
        <Form
          name="basic"
          layout="vertical"
          ref={this.form}
          initialValues={{
            webhook_url: currentIntegration
              ? currentIntegration.webhook_url
              : '',
            name: currentIntegration ? currentIntegration.name : '',
          }}
          style={{ position: 'relative' }}
        >
          <label>Webhook URL </label>
          <div className={styles.popover_modal}>
            <Popover className={styles.popover_modal} content={popoverContent}>
              <InfoCircleFilled
                style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  marginLeft: '90px',
                  color: 'white',
                }}
              />
            </Popover>
          </div>

          <Form.Item
            name="webhook_url"
            rules={[{ required: true, message: 'Webhook_URL is required' }]}
          >
            <Input />
          </Form.Item>
          <label>Integration name</label>
          <Form.Item name="name">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default WebhookModal;
